import { createSlice } from "@reduxjs/toolkit";

export const navSlice = createSlice({
  name: "nav",
  initialState: {
    activePart: null,
    drawerOpen: false,
    nitrumOpen: false,
    preloaderVisible: false,
    backgroundVisible: false,
    popover: null,
    modal: null,
    tooltip: null,
    viewport: null
  },
  reducers: {
    openDrawer: (state, action) => {
      state.drawerOpen = true;
      state.activePart = action.payload;

      // close nitrum
      state.nitrumOpen = false;
    },
    closeDrawer: (state) => {
      state.drawerOpen = false;
      state.activePart = null;
    },
    openNitrum: (state) => {
      state.nitrumOpen = true;

      // close drawer
      state.drawerOpen = false;
      state.activePart = null;
    },
    closeNitrum: (state) => {
      state.nitrumOpen = false;
    },
    showPreloader: (state) => {
      state.preloaderVisible = true;
    },
    hidePreloader: (state) => {
      state.preloaderVisible = false;
    },
    toggleBackground: (state) => {
      state.backgroundVisible = !state.backgroundVisible;
    },
    showPopover: (state, action) => {
      state.popover = action.payload;
    },
    hidePopover: (state) => {
      state.popover = null;
    },
    showModal: (state, action) => {
      state.modal = action.payload;
    },
    hideModal: (state) => {
      state.modal = null;
    },
    showTooltip: (state, action) => {
      state.tooltip = action.payload;
    },
    hideTooltip: (state) => {
      state.tooltip = null;
    },
    setViewport: (state, action) => {
      state.viewport = action.payload;
    }
  },
});

export const {
  openDrawer,
  closeDrawer,
  openNitrum,
  closeNitrum,
  showPreloader,
  hidePreloader,
  toggleBackground,
  showPopover,
  hidePopover,
  showModal,
  hideModal,
  showTooltip,
  hideTooltip,
  setViewport
} = navSlice.actions;

export default navSlice.reducer;
